import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from '@/router'
import { onBeforeUnmount, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { UserModule } from '@/store/modules/user'
import { getUserInfoApi } from '@/api/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const states: string[] = ['normal', 'hover', 'pressed']
const menus = [
  {
    prefixes: 'ASR',
    path: '/asr'
  },
  {
    prefixes: 'TTS',
    path: '/tts'
  },
  {
    prefixes: 'subtitles',
    path: '/sg'
  },
  {
    prefixes: 'OCR',
    path: '/ocr'
  },
  {
    prefixes: 'MT',
    path: '/mt?key=txtMT'
  },
  {
    prefixes: 'TA',
    path: '/doc'
  },
  {
    prefixes: 'meeting',
    path: '/meeting'
  }
]
const activeIndex = ref<number>(-1)
const activeState = ref<string>('normal')

function changeImage(index: number, state: string): void {
  const stateIndex = states.indexOf(state)
  if (stateIndex >= 0) {
    activeIndex.value = index
    activeState.value = state
  }
}
function getImagePath(index: number): string {
  const prefix: string = menus[index].prefixes
  if (index === activeIndex.value) {
    return require(`@/assets/img/menu/btn_${prefix}_${activeState.value}.png`)
  } else {
    return require(`@/assets/img/menu/btn_${prefix}_normal.png`)
  }
}
const router = useRouter()
function handleToPage(path: string) {
  router.push(path)
}

const dateTime = ref('')
const dateTimeTimer = ref(-1)
function updateDateTime() {
  dateTime.value = dayjs().format('MM月DD日  |  HH:mm:ss')
}
onMounted(() => {
  dateTimeTimer.value = window.setInterval(() => {
    updateDateTime()
  }, 1000)
})
onBeforeUnmount(() => {
  window.clearInterval(dateTimeTimer.value)
  dateTimeTimer.value = -1
})
function handleExit() {
  UserModule.LogOut()
}
const userName = ref('')
getUserInfo()
async function getUserInfo() {
  try {
    let res = await getUserInfoApi()
    userName.value = res.data.username
  } catch (error) {
    error
  }
}

return { __sfc: true,states, menus, activeIndex, activeState, changeImage, getImagePath, router, handleToPage, dateTime, dateTimeTimer, updateDateTime, handleExit, userName, getUserInfo }
}

})